import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatSidenavModule } from '@angular/material/sidenav'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src'
import { GbBreakpointService } from 'libs/gb-dashboard/shared/utils/src/lib/gb-breakpoint-service/gb-breakpoint.service'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { map, Observable } from 'rxjs'

@Component({
  selector: 'gb-presenter-elements-sidebar',
  imports: [CommonModule, MatSidenavModule, NgScrollbarModule, GbDashboardSharedUiModule, MatButtonModule],
  templateUrl: './gb-presenter-elements-sidebar.component.html',
  styleUrl: './gb-presenter-elements-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterElementsSidebarComponent {
  collapseMenu$: Observable<boolean> = this.gbBreakpointService.desktopView$.pipe(map((desktopView) => !desktopView))

  mode$: Observable<'over' | 'push'> = this.collapseMenu$.pipe(
    map((smBreakpoint) => {
      return smBreakpoint ? 'over' : 'push'
    }),
  )

  constructor(private gbBreakpointService: GbBreakpointService) {}
}
